import React from 'react';

const SpeedSlider = ({ speed, onChange }) => {
    const speeds = [1, 2, 3, 4];
    const labels = ['1x', '2x', '3x', '4x'];

    return (
        <div className="w-full">
            <input
                type="range"
                min="0"
                max="3"
                step="1"
                value={speeds.indexOf(speed)}
                onChange={(e) => onChange(speeds[e.target.value])}
                className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer"
            />
            <div className="flex justify-between mt-2">
                {labels.map((label, index) => (
                    <span key={index} className="text-xs">{label}</span>
                ))}
            </div>
        </div>
    );
};

export default SpeedSlider;